/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const inputs = feature.getInputs();
    const ID = feature.getID();
    const METHOD = feature.getSettingValue('METHOD');
    const INTERFACE = 'current_interface';
    const URL = `${feature.getSettingValue('URL')}`;
    const HEADERS = feature.getSettingValue('HEADERS');
    const CERTIFICATEFILE = feature.getSettingValue('CERTIFICATEFILE');
    let links = project.getNodeLinks(feature, 'http_request_start');
    const urlVariableName = `http_request_url_${feature.getID()}`;



    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        id: 'import requests',
        template: `
import requests`,
    });

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
${urlVariableName} = ""
        `,
    });


    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        id: 'def http_request',
        blockType: BlockType.CODE,
        template: `
def http_request(method, url, data_payload=None, headers=None, ssl_cert=None):
    try:
        json_payload = None
        if 'Content-Type' in headers and headers['Content-Type'] == 'application/json':
            json_payload = json.loads(data_payload)
            data_payload = None
        response = requests.request(method, url, data=data_payload, headers=headers, json=json_payload)
        if response.status_code not in range(200, 300):
            raise Exception('HTTP error: {}'.format(response.status_code))
        data = response.text
        #****callback_http_content_arrival****#
        #****callback_http_request_completed****#
        gc.collect()
    except Exception as error_message:
        error_message = str(error_message)
        #****callback_http_request_failed****#
        pass
    `,
    });

    const headers: { [key: string]: string } = {};
    for (let i = 0, len = HEADERS.length; i < len; i += 1) {
        const header = HEADERS[i];
        headers[header.getSettingValue('NAME')] = header.getSettingValue('VALUE');
    }

    for (let i = 0; i < links.length; i += 1) {
        const link = links[i];
        const source = project.getFeature(links[0].getSettingValue('SOURCE_FEATURE')) as BaseNode;
        const sourceParams = source.getPort(links[0].getSettingValue('SOURCE_PORT'))?.params;
        const data = project.getNodeParameter(link, 'data');
        blocks.push({
            location: link.getSourceId(),
            blockType: BlockType.CODE,
            id: link.getID(),
            template: `
global ${urlVariableName}            
${urlVariableName}=${project.parseCodeExpression(URL, sourceParams, TibboDataType.STRING)}
http_request('${METHOD.replace('HTTP_', '')}', ${urlVariableName}, data_payload=${data}, headers=${JSON.stringify(headers)})`,
        });
    }

    links = project.getNodeLinks(feature, 'http_data_arrival');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_content_arrival',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
print(${urlVariableName})
if url == ${urlVariableName}:
    #****${link.getSourceId()}****#
    pass
`,
        });
    }

    links = project.getNodeLinks(feature, 'http_complete');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_request_completed',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
if url == ${urlVariableName}:
    #****${link.getSourceId()}****#
    pass`,
        });
    }

    links = project.getNodeLinks(feature, 'http_error');
    if (links.length > 0) {
        const link = links[0];
        blocks.push({
            location: 'callback_http_request_failed',
            blockType: BlockType.CODE,
            id: link.getSourceId(),
            template: `
if url == ${urlVariableName}:
    #****${link.getSourceId()}****#
    pass`,
        });
    }

    return blocks;
};
